<template>
    <div>
        <FilterTable 
        :resource_name="resource_name"
        :title="title"
        :field_definitions="field_definitions"
        :filters="filters"
        :action_buttons="action_buttons"
        :row_actions="row_actions"
        :translate_to_display_data="translate_to_display_data"
        :route_root="route_root"
        :handle_row_action="handle_row_action"
        :full_text_search="true"
        :handle_action_button_click="handle_action_button_click"
        :update_flag="filter_table_update_flag"
      />
      <el-dialog 
        title="設定開放時間"
        :visible="is_open"
        :append-to-body="true"
        @close="is_open=false"
        :boolean="false">
        <RadioWithDatePicker
          :publish_setting="metadata.publish_setting"
          :options="options"
          :start_date="metadata.start_date"
          :end_date="metadata.end_date"
          :handle_dynamic_form_update="handle_dynamic_form_update"
        />
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="save_online_setting()">確 定</el-button>
        </div>
      </el-dialog>
      <LoadingBlock
          :active="loading">
      </LoadingBlock>
    </div>
</template>

<script>
import breadcrumbMixin from '@/mixins/breadcrumbMixin'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import RadioWithDatePicker from '@/components/backstage/RadioWithDatePicker/RadioWithDatePicker'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import api from '@/api/index'

export default {
  mixins: [breadcrumbMixin],
  components: {
    FilterTable,
    RadioWithDatePicker,
    LoadingBlock,
  },
  created() {
    this.permission_check({
      resource_info: { name: this.page_name.PAGE_LATEST_NEWS_MANAGEMENT },
      access: { name: this.permission.VIEW },
      reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
    })
  },
  data() {
    return {
        resource_name: 'news',
        title: '最新消息管理',
        route_root: 'front-stage-management/latest-news-management',
        field_definitions: [
          {
            display: {
              name: '標題',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'news_title',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '公告日期',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'opening_time_start',
              data_type: 'datetime',
            }
          },
          {
            display: {
              name: '下架日期',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'opening_time_end',
              data_type: 'datetime',
            }
          },
          {
            display: {
              name: '自動/排程',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'opening_mode',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '最後更新日期',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'updated_time',
              data_type: 'datetime',
            }
          },
        ],
        action_buttons: {
          add: {
            label: '新增公告',
            action: 'add'
          },
        },
        row_actions: {
          online: {
            label: '公告',
            action: 'online',
            enable: (row) => this.check_row('online', row)
          },
          offline: {
            label: '下架',
            action: 'offline',
            enable: (row) => this.check_row('offline', row)
          },
          edit: {
            label: '編輯',
            action: 'edit',
          },
          delete: {
            label: '刪除',
            action: 'delete',
          },
        },
        filters: {},
        loading: false,
        filter_table_update_flag: 0,
        options: [
          {
            value: "手動",
            label: "立即公告",
          },
          {
            value: "排程",
            label: "公告日期",
          }
        ],
        is_open: false,
        metadata: {},
      }
  },
  methods: {
      check_row(action, row) {
        if(action == 'online') {
          return row.current_status ? false : true
        }else if(action == 'offline'){
          return row.current_status ? true : false
        }else {
          return false
        }
      },
      translate_to_display_data(data) {
        console.log('translate_to_display_data')

        let types = {}
        this.field_definitions.forEach(
          function (field) {
            types[field['source']['key']] = field['source']['data_type']
          })

        let translated_data = data
        
        for (let key in data) {
          if (types[key] === 'datetime' && data[key]) {
            translated_data[key] = data[key].date.slice(0,-7)
          }
        }
        
        return translated_data
      },
      handle_row_action (action, index, row) {
        console.log('LatestNewsManagement: action:' + action + ', index: ' + index + ', row: ', row)

        switch(action){ 
          case 'online':
            // set visible for dialog to true
            this.is_open = true

            // init metadata
            this.$set(this.metadata, 'id', row.id)
            this.$set(this.metadata, 'publish_setting', row.opening_mode)
            if(row.opening_mode == '排程') {
              this.$set(this.metadata, 'start_date', row.opening_time_start!==undefined ? row.opening_time_start.substring(0, 10) : '')
              this.$set(this.metadata, 'end_date', row.opening_time_end!==undefined ? row.opening_time_end.substring(0, 10) : '')
            }
            console.log('this.metadata: ', this.metadata)
            break
          case 'offline':
            this.$set(this.metadata, 'id', row.id)
            this.$set(this.metadata, 'publish_setting', '手動')
            // api for offline directly (manually)
            let news_offline_setting = {
              id: row.id,
              opening_mode: '手動',
              opening_manual_switch: 0,
            }
            this.handle_online_news(news_offline_setting).then(
              string => {
                this.$message({
                  type: 'success',
                  message: '下架設定完成!'
                })
              }
            ).catch(
              response => {
                this.$message({
                  type: 'success',
                  message: '下架設定失敗，請聯絡系統管理員!'
                })
              }
            )
            break
          case 'edit': 
            this.backstage_router_push({ path: `/${this.route_root}/edit/${row.id}` })
            break
          case 'delete': 
            this.$confirm('此操作將刪除該最新消息，是否繼續?', '提示', {
              confirmButtonText: '確定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.handle_delete_news(row.id).then(
                string => {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                }
              ).catch(
                response => {
                  this.$message({
                    type: 'success',
                    message: '删除失敗，請聯絡系統管理員!'
                  })
                }
              )
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
            break
          default:
            break
        }
      },
      handle_action_button_click (action) {
        console.log('LatestNewsManagement: action button clicked: ', action)

        switch(action){
          case 'add': 
            this.backstage_router_push({ path: `/${this.route_root}/add` })
            break
          default:
            break
        }
      },
      handle_do_update () {
        this.filter_table_update_flag += 1
      },
      handle_dynamic_form_update (key, form_value) {
        console.log('LatestNewsManagement: handle_dynamic_form_update:' + key + ', value:', form_value)
        this.$set(this.metadata, key, form_value)
      },
      save_online_setting() {
        let news_online_setting = {
          id: this.metadata.id,
          opening_mode: this.metadata.publish_setting,
          opening_manual_switch: 1,
        }
        if(this.metadata.publish_setting === '排程'){
          if(this.metadata.start_date===undefined || this.metadata.start_date===null) {
            this.notify_message(this.ERROR.LEVEL.WARN, '預定上架日期為必填', '')
            return
          }
          news_online_setting['opening_time_start'] = this.metadata.start_date
          news_online_setting['opening_time_end'] = this.metadata.end_date
        }
        this.handle_online_news(news_online_setting).then(
          res => {
            this.notify_message(this.ERROR.LEVEL.SUCCESS, '公告設定完成!', '')
          }
        ).catch(
          response => {
            this.notify_message(this.ERROR.LEVEL.ERROR, '公告設定失敗', '請聯絡系統管理員!')
          }
        )
      },
      async handle_online_news(news_online_setting) {
        console.log('news online setting: ', news_online_setting)
        this.loading = true
        await api.online_news(news_online_setting)
        this.loading = false
        this.is_open = false
        this.filter_table_update_flag += 1
      },
      async handle_delete_news(id) {
        console.log('delete news: id=', id)
        this.loading = true
        await api.delete_news(id)
        this.loading = false
        this.filter_table_update_flag += 1
      },
    },
};
</script>

<style>
</style>
